
const digest = 'd3543af52de849fbc1108153608ff4675e0d23d27d2495418c55277e3d15d1e2';
const classes = {"wrapper":"_wrapper_n1nnd_1","item":"_item_n1nnd_24","status":"_status_n1nnd_43"};
const css = `._wrapper_n1nnd_1 {
  font-family: Rubik, "sans-serif";
  width: 100%;
  flex: 1;
}
._wrapper_n1nnd_1 table {
  width: 100%;
}
._wrapper_n1nnd_1 table thead {
  background: #fbfbfd;
}
._wrapper_n1nnd_1 table thead tr th {
  color: #3e3f42;
  font-size: 12px;
  font-weight: 400;
  padding: 14px 8px;
}
._wrapper_n1nnd_1 table thead tr th:first-of-type {
  padding-left: 14px;
}
._wrapper_n1nnd_1 table thead tr th:last-of-type {
  padding-right: 14px;
}
._wrapper_n1nnd_1 table ._item_n1nnd_24 {
  color: #000000;
  font-size: 14px;
  font-weight: 400;
  background-color: #ffffff;
  border: 1px solid #eaedf3;
}
._wrapper_n1nnd_1 table ._item_n1nnd_24:nth-child(even) {
  background-color: #fbfbfd;
}
._wrapper_n1nnd_1 table ._item_n1nnd_24 td {
  padding: 14px 8px;
}
._wrapper_n1nnd_1 table ._item_n1nnd_24 td:first-of-type {
  padding-left: 14px;
}
._wrapper_n1nnd_1 table ._item_n1nnd_24 td:last-of-type {
  padding-right: 14px;
}
._wrapper_n1nnd_1 table ._item_n1nnd_24 ._status_n1nnd_43 {
  font-weight: 600;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  